export default "__VITE_ASSET__DOTst$BF__"